import React, { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { CalendarProps } from "./types";
import ReservationListModal from "../../pages/ReservationListModal/ReservationListModal";

const MyCalendar: React.FC<CalendarProps> = ({ events }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const dayClickRef = useRef(null);
  console.log('EventList: ', events)

  const handleDateClick = (arg: any) => {
    const selectedDate = new Date(arg.date).toISOString(); // Convierte la fecha a un formato ISO
    setSelectedDate(selectedDate);
    setIsModalOpen(true);
  };

  const handleEventClick = (eventInfo: any) => {
    const eventDate = eventInfo.event.start.toISOString(); // Obtén la fecha del evento en formato ISO
    setSelectedDate(eventDate);
    setIsModalOpen(true);
  };

  const formatDateRange = (startDate?: Date, endDate?: string): string => {
    const formattedStartDate = startDate
    ? startDate.toLocaleDateString("es-ES", {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    : "dd/mm/yy";
  
    const formattedEndDate = endDate
    ? endDate
        .split('-')
        .reverse()
        .map((component) => component.padStart(2, '0'))
        .join('/')
    : "dd/mm/yy";
  
    return `${formattedStartDate} - ${formattedEndDate}`;
  };
  

  useEffect(() => {
    // Este efecto se ejecutará cada vez que selectedDate cambie
    if (selectedDate) {
      // Aquí puedes realizar acciones con la fecha seleccionada, como enviarla al modal o hacer cualquier otra operación necesaria
    }
  }, [selectedDate]);

  // Función para renderizar el contenido de los eventos
  const renderEventContent = (eventInfo: any) => {
    console.log('Events: ', events);
    console.log('Event Start: ', eventInfo.event.start);
    console.log('Event End: ', eventInfo.event.end);

    // Convierte la fecha de eventInfo.event.start al formato 'YYYY-MM-DD'
    const formattedEventStartDate = new Date(eventInfo.event.start).toISOString().split('T')[0];

    // Encuentra el evento correspondiente en el array events por su start date
    const correspondingEvent = events.find((event) => event.start === formattedEventStartDate);

    // Accede a la propiedad finish de ese evento
    const endDate = correspondingEvent ? correspondingEvent.finish : eventInfo.event.start;

    return (
      <div onClick={() => handleEventClick(eventInfo)}
      data-date={eventInfo.event.start.toISOString()} // Adjuntar la fecha del evento como atributo de datos
      >  
      <ReservationListModal
        eventTitle={eventInfo.event.title}
        eventDate={selectedDate}
        category={eventInfo.event.category}
        category_image={eventInfo.event.extendedProps.icon}
        dateRange={formatDateRange(eventInfo.event.start, endDate)}
      />
      </div>
    );
  };

  const isSmallDevice = window.innerWidth <= 800; // Define your breakpoint

  const eventDays = events.map((event) => new Date(event.start).toDateString());

  return (
    <>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        events={events}
        selectable={true}
        editable={true}
        eventContent={renderEventContent}
        eventClick={handleEventClick}
        dateClick={handleDateClick}
        height={isSmallDevice ? 700 : 800}
      />
    </>
  );
};

export default MyCalendar;